module.exports = __webpack_public_path__ + "img/cityApplyen.8015e4bb.png";